/* tslint:disable */

declare var Object: any;
export interface SFOvtCancelRequestInterface {
  "id"?: number;
}

export class SFOvtCancelRequest implements SFOvtCancelRequestInterface {
  "id": number;
  constructor(data?: SFOvtCancelRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFOvtCancelRequest`.
   */
  public static getModelName() {
    return "SFOvtCancelRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFOvtCancelRequest for dynamic purposes.
  **/
  public static factory(data: SFOvtCancelRequestInterface): SFOvtCancelRequest{
    return new SFOvtCancelRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFOvtCancelRequest',
      plural: 'SFOvtCancelRequests',
      path: 'SFOvtCancelRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFOvtCancelRequest.ts